import React from 'react';
import { BulkPrintHistoryCreateTemplate } from 'themes/modules/order/pages';
import { BulkPrintHistoryViewStore } from 'modules/order/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new BulkPrintHistoryViewStore(rootStore, componentProps), 'bulkPrintHistoryViewStore')
class BulkPrintHistoryCreate extends React.Component {
	render() {
		return <BulkPrintHistoryCreateTemplate {...this.props} />;
	}
}

export default BulkPrintHistoryCreate;
